module.exports = __webpack_public_path__ + "static/media/MembersIconInactive.38ee8fd5.png";